import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ApiProvider } from "./lib/api";
import configureStore, { history } from "./lib/store/_store";
import { initAmplitude } from "./lib/utils/amplitude";
import { initZharp } from "./lib/utils/zharp";

import "rsuite/lib/styles/index.less";
import "./styles/App.scss";
import "./index.less";
import "./styles/main.scss";
import App from "./App.jsx";

import * as serviceWorker from "./serviceWorker";

const store = configureStore();

initZharp();
initAmplitude();

ReactDOM.render(
  <Provider store={store}>
    <ApiProvider>
      <App history={history} />
    </ApiProvider>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
